import * as React from "react";
const IconPassword = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.9863 7.99243H8.98633M16.9863 7.99243C19.1955 7.99243 20.9863 9.78329 20.9863 11.9924V17.9924C20.9863 20.2016 19.1955 21.9924 16.9863 21.9924H8.98633C6.77719 21.9924 4.98633 20.2016 4.98633 17.9924V11.9924C4.98633 9.78329 6.77719 7.99243 8.98633 7.99243M16.9863 7.99243V5.99243C16.9863 3.78329 15.1955 1.99243 12.9863 1.99243C10.7772 1.99243 8.98633 3.78329 8.98633 5.99243V7.99243M14.9863 14.9924C14.9863 16.097 14.0909 16.9924 12.9863 16.9924C11.8818 16.9924 10.9863 16.097 10.9863 14.9924C10.9863 13.8879 11.8818 12.9924 12.9863 12.9924C14.0909 12.9924 14.9863 13.8879 14.9863 14.9924Z"
      stroke="#1C1C2C"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default IconPassword;
